"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import SinteredLayersDiagram from "@/components/diagrams/SinteredLayersDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const DIAGRAM_COPY = {
  en: {
    title: "Structural Diagram: Sintered Dutch Weave Mesh Layer Stackup",
    lead: "Microstructural schematic showing how protective outer wire cloth, dense Dutch weave filtration core, buffer dispersion layer, and heavy structural support skeleton are diffusion-bonded into an incompressible monolithic filter plate."
  },
  zh: {
    title: "结构剖析：荷兰编织烧结网层叠结构示意图",
    lead: "微观复合层叠结构示意，展示表面保护网、荷兰密纹核心精滤层、流体缓冲层及重型骨架支撑层如何在真空高温环境下固相扩散焊接为整体式滤板。"
  },
  es: {
    title: "Diagrama estructural: laminado de malla holandesa sinterizada",
    lead: "Esquema microestructural que muestra la unión por difusión de la capa protectora exterior, el núcleo holandés de filtración, la capa de amortiguación y el soporte rígido."
  },
  de: {
    title: "Strukturdiagramm: Schichtaufbau des gesinterten Tressengewebes",
    lead: "Mikrostrukturelles Schema zur Darstellung, wie äußere Schutzlage, Tressengewebe-Filterkern, Pufferlage und schweres Stützskelett diffusionsgebunden werden."
  },
  fr: {
    title: "Schéma structurel : empilement des couches de toile hollandaise frittée",
    lead: "Schéma microstructural illustrant la liaison par diffusion de la couche protectrice, du cœur filtrant reps, de la couche tampon et de l'armature de renfort."
  },
  pt: {
    title: "Diagrama estrutural: composição em camadas da malha holandesa sinterizada",
    lead: "Esquema microestrutural demonstrando a união por difusão da malha protetora, núcleo de trama holandesa, amortecedor de fluxo e esqueleto estrutural de suporte."
  }
};
export default function SinteredDutchWeaveMeshPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = pick(lang, DIAGRAM_COPY);
  const diagram = <DiagramSection id="layer-structure" title={diagramCopy.title} lead={diagramCopy.lead} tone="background">
      <div className="max-w-4xl mx-auto rounded-lg border border-border bg-card p-6 md:p-8">
        <SinteredLayersDiagram variant="dutch" />
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}